export class FsDolpShare {
  public id: string;

  public canEdit?: boolean;

  public canView?: boolean;

  public isAdmin?: boolean;

  public share?: boolean;

  public firstName: string;

  public lastName: string;

  public email: string;

  public lastLogin: Date;

  constructor() {}
}
